<template>
    <div>
        <hts-form-autocomplete
            :label="props.label"
            :required="true"
            :server="serverDriver"
            :text="partnerName"
            key-id="_id"
            :placeholder="props.placeHolder"
            :permissions-add="layoutPermissions[`${props.type}_add`]"
            :add="props.showAddIcon"
            :company-type="props.type"
            :disabled="props.disabled"
            @add="handleAdd"
            @change="(customer:any) => setPartner(customer)">
            <template #suffix>
                <hi-x-mark-icon
                    v-if="props.showRemoveIcon"
                    class="h-6 w-6 cursor-pointer opacity-60 hover:opacity-80"
                    @click="deleteResults" />
            </template>
        </hts-form-autocomplete>

        <!-- Kết quả tìm kiếm: {{ partnerId }} -->

        <add
            :type="props.type"
            :show="showSlideOverAdd"
            @close="showSlideOverAdd = false"
            @new-partner="(partner:any) => setPartner(partner)" />
    </div>
</template>
<script lang="ts" setup>
import Add from './add.vue'
import layoutPermissions from '@/data/permissions/layout-permissions'

const props = defineProps({
  type: {
    type: String,
    required: true
  },
  label: String,
  customerName: String,
  placeHolder: String,
  showRemoveIcon: {
    type: Boolean,
    default: true
  },
  showAddIcon: {
    type: Boolean,
    default: true
  },
  cooperatorIsSelected: {
    type: Object,
    default: () => {}
  },
  disabled: {
    type: Boolean,
    default: false
  }
})
const emits = defineEmits(['change', 'add'])
const partnerId = ref('')
const partnerName = ref('')
const serverDriver = $urlClient.partner.find
const showSlideOverAdd = ref(false)

onMounted(() => {
  if (props.cooperatorIsSelected) {
    partnerName.value = props.cooperatorIsSelected.ownerName
    partnerId.value = props.cooperatorIsSelected.owner
  }
})
const setPartner = (partner: any) => {
  partnerName.value = partner.name
  partnerId.value = partner._id
  emits('change', partner)
}

const deleteResults = () => {
  partnerName.value = 'deleteResults'
  partnerId.value = ''
}
const handleAdd = () => {
  showSlideOverAdd.value = true
  emits('add')
}
</script>
